export default __webpack_public_path__ + "static/media/rude.c35f95a1.gif";